export const SENIOR_ADMIN = {id : 26, slug: 'senior_admin'};
